export default "/fonts/vendor/primeicons/primeicons.eot?7fc4d8e224d1ff1b9c6256b15cbe43a7";